import React from "react";
import { TaskItemProps } from "../task-item";
import styles from "./project.module.css";
import { truncateText } from "../../../helpers/tuncated-text";

export const Project: React.FC<TaskItemProps> = ({
  task,
  isSelected,
  onMilestoneMouseEnter,
  onMilestoneMouseLeave,
}) => {

  const barColor = isSelected
    ? task.styles.backgroundSelectedColor
    : task.styles.backgroundColor;

  const minBarWidth = 21;
  const projectWidth = Math.max(task.x2 - task.x1, minBarWidth);
  const left = task.x1;
  const right = left + projectWidth;

  const projectLeftTriangle = [
    left,
    task.y + task.height / 2 + 5,
    left,
    task.y + task.height,
    left + 15,
    task.y + task.height / 2 + 5,
  ].join(",");

  const projectRightTriangle = [
    right,
    task.y + task.height / 2 + 5,
    right,
    task.y + task.height,
    right - 15,
    task.y + task.height / 2 + 5,
  ].join(",");

  if (typeof task.showProgress !== "boolean") {
    task.showProgress = true;
  }

  return (
    <g
      tabIndex={0}
      className={styles.projectWrapper}
      id={task.id}
      data-taskid={task.id}
      data-type="Task"
    >
      {/* Filled portion of the progress bar */}
      <rect
        data-taskid={task.id}
        data-type="Task"
        x={task.progressX}
        width={Math.max(task.progressWidth, 0)}
        y={task.y}
        height={task.height / 2 + 5}
        rx={0}
        ry={task.barCornerRadius}
        className="rounded-t-sm"
        fill={barColor}
      />

      {/* Background of the bar */}
      <rect
        data-taskid={task.id}
        data-type="Task"
        fill={barColor + "a4"}
        x={left}
        width={projectWidth}
        y={task.y}
        height={task.height / 2 + 5}
        rx={0}
        ry={task.barCornerRadius}
        className={styles.projectTop + " rounded-t-md"}
      />

      {/* Task Name Text */}
      {projectWidth > 20 && (
        <text
          data-taskid={task.id}
          x={left + 5}
          y={task.y + task.height / 2 + 2}
          fontSize={Math.min(12, projectWidth / 4)}
          fill="#fff"
          className="pointer-events-none select-none"
        >
          {truncateText(task.name, projectWidth)}
        </text>
      )}

      {/* Progress Percentage */}
      {projectWidth > 30 && task.showProgress && (
        <text
          data-taskid={task.id}
          x={
            Number(task.progress) === 100
              ? left + projectWidth - 35
              : left + projectWidth - 30
          }
          y={task.y + task.height / 2}
          fontSize={Math.min(12, projectWidth / 5)}
          fill="#fff"
          className="pointer-events-none select-none"
        >
          {Number(task.progress).toFixed()}%
        </text>
      )}

      {/* Left Triangle - only if enough space */}
      {projectWidth > 30 && task.progressWidth > 15 && (
        <polygon
          data-taskid={task.id}
          className={styles.projectTop}
          points={projectLeftTriangle}
          fill={barColor}
        />
      )}
      {projectWidth > 20 && (
        <polygon
          data-taskid={task.id}
          className={styles.projectTop}
          points={projectLeftTriangle}
          fill={barColor + "a4"}
        />
      )}

      {/* Right Triangle - optional overlay */}
      {projectWidth > 20 && (
        <polygon
          className={styles.projectTop}
          points={projectRightTriangle}
          fill={barColor + "a4"}
        />
      )}
      {Math.round(task.progressWidth) === Math.round(projectWidth) &&
        projectWidth > 30 && (
          <polygon
            data-taskid={task.id}
            className={styles.projectTop}
            points={projectRightTriangle}
            fill={barColor}
          />
        )}

      {/* Render Milestones as Diamonds */}
      {task.milestones && 
       task.milestones.length > 0 && 
       (task.id.endsWith("-act") || (!task.id.endsWith("-recalc") && (!task.id.endsWith("-est") || !task.baseLineTask?.length))) &&
       task.milestones.map((milestone) => {
        const diamondSize = 12;
        const barHeight = task.height / 2 + 5;
        const centerY = task.y + barHeight / 2;
        const transform = `rotate(45 ${milestone.x} ${centerY})`;

        return (
          <g key={milestone.id} className="milestone-marker">
            {/* <text
              x={milestone.x}
              y={isProjectsPage ? task.y + (task.height / 2 + 5) + 15 : task.y - 6}
              textAnchor="middle"
              fontSize="10"
              fontWeight="600"
              fill="#1e293b"
              className="select-none pointer-events-none"
              style={{
                paintOrder: 'stroke',
                stroke: '#fff',
                strokeWidth: '3px',
                strokeLinejoin: 'round' as const,
              }}
            >
              {milestone.name}
            </text> */}
            <rect
              x={milestone.x - diamondSize / 2}
              y={centerY - diamondSize / 2}
              width={diamondSize}
              height={diamondSize}
              fill={milestone.color || barColor}
              stroke="#ffffff"
              strokeWidth="1.5"
              transform={transform}
              className="pointer-events-none"
              style={{ filter: 'drop-shadow(0px 1px 2px rgba(0,0,0,0.25))' }}
            />
            {onMilestoneMouseEnter && onMilestoneMouseLeave && (
              <rect
                data-milestone-hit="true"
                x={milestone.x - 10}
                y={centerY - 10}
                width={20}
                height={20}
                fill="transparent"
                className="cursor-pointer"
                style={{ pointerEvents: "auto" }}
                onMouseEnter={(e) => {
                  e.stopPropagation();
                  onMilestoneMouseEnter(e, milestone);
                }}
                onMouseLeave={(e) => {
                  e.stopPropagation();
                  onMilestoneMouseLeave(e);
                }}
              />
            )}
          </g>
        );
      })}
    </g>
  );
};
